/* import __COLOCATED_TEMPLATE__ from './avatar.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();